import styled from 'styled-components';

export const InputContainer = styled.div`
  width: 100%;
  height: 75px;
  background-color: #AAFFAA;

  display: flex;
  align-items: center;
  justify-content: flex-end;

  font-size: 24px;
  font-family: 'Roboto';

  input {
  width: 100%;
  height: 75px;
  background-color: #AAFFAA;
  border: 0;
  float: right;
  font-size: 32px;
  padding: 0 10px;
  text-align: right;
  }
`